module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/Export-519fb8a9f234f7dfab12544708017e05a9644df3413e3a8ed76b465dd0dbd808.svg";